<template>
  <div class="courses-section">
    <h2 class="section-title">
      <i class="fas fa-book"></i> Courses 
      <span class="count-badge">{{ courses?.length || 0 }}</span>
    </h2>
    <div class="section-card">
      <div v-if="courses?.length" class="courses-list">
        <div v-for="course in courses" :key="course.id" class="course-card">
          <div class="course-header">
            <h3>{{ course.title }}</h3>
            <span class="course-status" :class="course.status.toLowerCase()">{{ course.status }}</span>
          </div>
          <div class="course-details">
            <span class="course-meta">
              <i class="fas fa-clock"></i> {{ course.minutes }} mins
            </span>
            <span class="course-meta">
              <i class="fas fa-tag"></i> ${{ course.price || 'Free' }}
            </span>
          </div>
          <div v-html="course.description" class="course-description"></div>
        </div>
      </div>
      <p v-else class="no-data-message">No courses available.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructorCourses',
  props: {
    courses: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.courses-section {
  margin-bottom: 2rem;
}

.section-title {
  margin: 0 0 1.25rem;
  color: #1e293b;
  font-size: 1.375rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title i {
  color: #3b82f6;
  font-size: 1.25rem;
}

.count-badge {
  background: #e2e8f0;
  color: #475569;
  font-size: 0.875rem;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  margin-left: 0.5rem;
}

.section-card {
  background: white;
  padding: 1.5rem;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 0.5rem;
}

.course-card {
  background: #f8fafc;
  padding: 1.25rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
}

.course-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.course-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.course-header h3 {
  margin: 0;
  color: #1e293b;
  font-size: 1.125rem;
}

.course-status {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-weight: 500;
}

.course-status.active {
  background: #dcfce7;
  color: #16a34a;
}

.course-status.draft {
  background: #fef3c7;
  color: #d97706;
}

.course-status.archived {
  background: #fee2e2;
  color: #ef4444;
}

.course-status.completed {
  background: #e0f2fe;
  color: #0284c7;
}

.course-details {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.course-meta {
  color: #64748b;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.course-description {
  color: #475569;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-top: 0.75rem;
}

.no-data-message {
  color: #94a3b8;
  text-align: center;
  font-style: italic;
  margin: 1rem 0;
}

@media (max-width: 768px) {
  .course-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .course-status {
    align-self: flex-start;
  }
}
</style> 